import './ButtonModule.css';
import ButtonTable from './img/button.png';

function ButtonModule() {
    return (
        <div>
            <h3>The Button</h3>
            <img src={ButtonTable} alt="" width="100%" />

          Alternative:<br />
          PRESS and RELEASE:<br />
              ≥2 batteries & “Detonate” and NOT (blue & “Abort”)<br />
              ≥3 batteries & label FRK and NOT (blue & “Abort”) and NOT (white & label CAR )<br />
red & “Hold”<br />

Otherwise HOLD<br />
        </div>
    );
}

export default ButtonModule;
